module.exports = "/_next/static/images/EnrichAudiences-5fa55fb4a34367ed8e4f8d3285b43761.webp";